const vP18372 = require("./306.js");
function f2191(p18373, p18374) {
  const v14103 = p18373.a / 255;
  const v14104 = p18374 + "=\"" + p18373.hex + "\"";
  if (v14103 < 1) {
    return v14104 + " " + p18374 + "-opacity=\"" + v14103.toFixed(2).slice(1) + "\"";
  } else {
    return v14104;
  }
}
function f2192(p18375, p18376, p18377) {
  let v14105 = p18375 + p18376;
  if (typeof p18377 != "undefined") {
    v14105 += " " + p18377;
  }
  return v14105;
}
function f2193(p18378, p18379, p18380) {
  let vLS119 = "";
  let vLN02599 = 0;
  let v14106 = false;
  let vLN02600 = 0;
  for (let vLN02601 = 0; vLN02601 < p18378.length; vLN02601++) {
    const v14107 = Math.floor(vLN02601 % p18379);
    const v14108 = Math.floor(vLN02601 / p18379);
    if (!v14107 && !v14106) {
      v14106 = true;
    }
    if (p18378[vLN02601]) {
      vLN02600++;
      if (!(vLN02601 > 0) || !(v14107 > 0) || !p18378[vLN02601 - 1]) {
        vLS119 += v14106 ? f2192("M", v14107 + p18380, 0.5 + v14108 + p18380) : f2192("m", vLN02599, 0);
        vLN02599 = 0;
        v14106 = false;
      }
      if (!(v14107 + 1 < p18379) || !p18378[vLN02601 + 1]) {
        vLS119 += f2192("h", vLN02600);
        vLN02600 = 0;
      }
    } else {
      vLN02599++;
    }
  }
  return vLS119;
}
exports.render = function (p18381, p18382, p18383) {
  const v14109 = vP18372.getOptions(p18382);
  const v14110 = p18381.modules.size;
  const v14111 = p18381.modules.data;
  const v14112 = v14110 + v14109.margin * 2;
  const v14113 = v14109.color.light.a ? "<path " + f2191(v14109.color.light, "fill") + " d=\"M0 0h" + v14112 + "v" + v14112 + "H0z\"/>" : "";
  const v14114 = "<path " + f2191(v14109.color.dark, "stroke") + " d=\"" + f2193(v14111, v14110, v14109.margin) + "\"/>";
  const v14115 = v14109.width ? "width=\"" + v14109.width + "\" height=\"" + v14109.width + "\" " : "";
  const v14116 = "<svg xmlns=\"http://www.w3.org/2000/svg\" " + v14115 + ("viewBox=\"0 0 " + v14112 + " " + v14112 + "\"") + " shape-rendering=\"crispEdges\">" + v14113 + v14114 + "</svg>\n";
  if (typeof p18383 == "function") {
    p18383(null, v14116);
  }
  return v14116;
};